{
  "account.backToSignIn": "Zurück zur Anmeldung",
  "account.birthDate": "Geburtsdatum",
  "account.birthDateHint": "Unter dem in deinem Land geforderten Alter besucht man ein Festival nicht allein.",
  "account.childProfile": "Kinderprofil",
  "account.country": "Land",
  "account.countryOption": "Land: {{name}}",
  "account.day": "Tag",
  "account.dayShort": "TT",
  "account.delete": "Mein Konto löschen",
  "account.deleteConfirm": "Endgültig löschen",
  "account.deleteExplain": "Dein Konto, deine Gruppen, deine geteilten Standorte und deine Erfassungen werden gelöscht, ebenso verknüpfte Kinderprofile. Das ist endgültig. Programm, Favoriten und Markierungen bleiben auf diesem Telefon.",
  "account.deletePasswordHint": "Gib dein Passwort zur Bestätigung ein.",
  "account.deleted": "Dein Konto wurde gelöscht.",
  "account.displayName": "Angezeigter Name",
  "account.email": "E-Mail-Adresse",
  "account.forgot": "Passwort vergessen?",
  "account.invalidCredentials": "Adresse oder Passwort falsch.",
  "account.invitationCode": "Einladungscode",
  "account.invitationHint": "Die Registrierung ist nicht offen: Ein Konto entsteht mit einem Code, den jemand aushändigt.",
  "account.invitationInvalid": "Dieser Einladungscode ist ungültig.",
  "account.invitationScanned": "Einladung erkannt: Füll das Formular aus.",
  "account.month": "Monat",
  "account.monthShort": "MM",
  "account.newPassword": "Neues Passwort",
  "account.open": "Konto",
  "account.password": "Passwort",
  "account.passwordHint": "Mindestens zwölf Zeichen.",
  "account.registrationFailed": "Die Registrierung konnte nicht abgeschlossen werden. Prüfe deine Angaben.",
  "account.resetCode": "Erhaltener Code",
  "account.resetConfirm": "Passwort ändern",
  "account.resetDone": "Passwort geändert. Melde dich mit dem neuen an.",
  "account.resetExplain": "Gib die Adresse deines Kontos ein: Wir senden einen sechsstelligen Code dorthin.",
  "account.resetInvalid": "Dieser Code ist ungültig oder abgelaufen. Fordere einen neuen an.",
  "account.resetSend": "Code anfordern",
  "account.resetSent": "Falls ein Konto diese Adresse nutzt, wurde soeben ein Code dorthin gesendet. Er ist 15 Minuten gültig.",
  "account.signIn": "Anmelden",
  "account.signOut": "Abmelden",
  "account.signUp": "Konto erstellen",
  "account.signedInAs": "Angemeldet als {{name}}",
  "account.title": "Mein Konto",
  "account.toggleToSignIn": "Ich habe bereits ein Konto",
  "account.toggleToSignUp": "Ich habe noch kein Konto",
  "account.tooMany": "Zu viele Versuche. Versuche es in ein paar Minuten erneut.",
  "account.tooYoung": "Das Konto muss von einer erwachsenen Person erstellt werden, die anschließend ein Kinderprofil daran knüpfen kann.",
  "account.unreachable": "Server nicht erreichbar. Versuche es erneut, sobald das Netz zurück ist.",
  "account.year": "Jahr",
  "account.yearShort": "JJJJ",
  "aerial.download": "Luftbild herunterladen",
  "aerial.downloading": "Wird geladen…",
  "aerial.explain": "Eine Drohnenaufnahme des Geländes. Sie belegt {{size}} MB auf deinem Telefon und wird nur einmal geladen.",
  "aerial.failed": "Herunterladen fehlgeschlagen. Versuche es im WLAN.",
  "aerial.ready": "Luftbild offline verfügbar",
  "aerial.remove": "Luftbild löschen",
  "aerial.title": "Luftbild",
  "aerial.wifiHint": "Am besten vor der Anreise, im WLAN.",
  "common.cancel": "Abbrechen",
  "common.close": "Schließen",
  "common.retry": "Erneut versuchen",
  "common.search": "Suchen",
  "crew.apiUnavailable": "Gruppe nicht verfügbar: kein Server konfiguriert",
  "crew.background.active": "Dein Standort wird auch mit dem Handy in der Tasche gesendet, etwa jede Minute, solange du dich bewegst.",
  "crew.background.allow": "Standort immer erlauben",
  "crew.background.foregroundOnly": "Deine Freunde sehen dich nur, wenn die App geöffnet ist.",
  "crew.background.notificationBody": "Bis {{time}}. Öffne die App, um es zu beenden.",
  "crew.background.notificationTitle": "Standort wird mit {{crew}} geteilt",
  "crew.codeLabel": "Gruppencode",
  "crew.create": "Gruppe erstellen",
  "crew.error.festival": "Dieses Festival ist noch nicht auf dem Server, daher kann keine Gruppe erstellt werden.",
  "crew.error.notFound": "Keine Gruppe hat diesen Code. Prüfe ihn mit der Person, die die Gruppe erstellt hat.",
  "crew.error.notMember": "Du gehörst nicht mehr zu dieser Gruppe, oder sie ist abgelaufen.",
  "crew.error.refused": "Der Server hat die Anfrage abgelehnt. Versuche es später erneut.",
  "crew.error.session": "Deine Sitzung ist abgelaufen. Melde dich erneut an.",
  "crew.error.tooMany": "Zu viele Versuche. Versuche es in ein paar Minuten erneut.",
  "crew.join": "Mit Code beitreten",
  "crew.lastSeen": "Vor {{minutes}} Min. gesehen",
  "crew.lastSeenDays": "Vor {{days}} T. gesehen",
  "crew.lastSeenHours": "Vor {{hours}} Std. gesehen",
  "crew.nameLabel": "Gruppenname",
  "crew.near": "Bei {{place}}",
  "crew.needAccount": "Für eine Gruppe wird ein Konto benötigt",
  "crew.noCrew": "Noch keine Gruppe",
  "crew.noPosition": "Teilt den Standort nicht",
  "crew.offline": "Offline – letzte bekannte Informationen",
  "crew.positionStale": "Alter Standort",
  "crew.rallyNeedPosition": "Aktiviere deinen Standort, um zu sehen, wo er ist",
  "crew.rallyOnMap": "Gruppentreffpunkt",
  "crew.rallySetAt": "Gesetzt um {{time}}",
  "crew.section.members": "Die Gruppe",
  "crew.section.sharing": "Mein Standort",
  "crew.setRally": "Hier einen Treffpunkt festlegen",
  "crew.shareCode": "Diesen Code scannen lassen oder vorlesen",
  "crew.shareOff": "Standortfreigabe deaktiviert",
  "crew.sharing.APPROXIMATE": "Ungefährer Bereich",
  "crew.sharing.OFF": "Nicht teilen",
  "crew.sharing.PRECISE": "Genauer Standort",
  "crew.sharingFor": "{{hours}} Std. teilen",
  "crew.sharingUntil": "Freigabe bis {{time}}",
  "crew.showOnMap": "Auf dem Plan zeigen",
  "crew.title": "Meine Gruppe",
  "crew.you": "Das bist du",
  "diary.empty": "Noch keine Konzerte markiert",
  "diary.markSeen": "Ich war dabei",
  "diary.notYet": "Noch nicht begonnen",
  "diary.photosCount": "{{count}} Foto(s) während des Festivals aufgenommen",
  "diary.photosDenied": "Zugriff auf Fotos verweigert",
  "diary.photosExplain": "Die Fotos bleiben auf dem Telefon: nichts wird kopiert oder hochgeladen.",
  "diary.photosNone": "Keine Fotos in diesem Zeitraum gefunden",
  "diary.photosPermission": "Zugriff auf Fotos erlauben",
  "diary.photosTitle": "Fotos von diesem Festival",
  "diary.stats": "{{performances}} Konzert(e) · {{artists}} Künstler · {{days}} Tag(e)",
  "diary.unmarkSeen": "Aus dem Tagebuch entfernen",
  "festival.checkedOn": "geprüft am {{date}}",
  "festival.reportHint": "Ein Fehler? Tippe auf diesen Hinweis oder drücke lange auf einen Auftritt oder Ort.",
  "festival.source": "Programm übernommen von: {{source}}",
  "festival.unofficial": "Inoffizielle Seite: Angaben nicht vom Veranstalter geprüft.",
  "keyring.add": "Ein Festival hinzufügen",
  "keyring.already": "Bereits in deinen Festivals",
  "keyring.change": "Festival wechseln",
  "keyring.current": "Gerade geöffnet",
  "keyring.empty": "Noch kein Festival hinzugefügt.",
  "keyring.noResult": "Kein Festival gefunden.",
  "keyring.offline": "Die Suche braucht Netz. Bereits hinzugefügte Festivals bleiben verfügbar.",
  "keyring.pinFailed": "Dein Telefon konnte das Symbol nicht hinzufügen.",
  "keyring.pinHint": "Ein Symbol für dieses Festival, das die App direkt darauf öffnet.",
  "keyring.pinShortcut": "Zum Startbildschirm hinzufügen",
  "keyring.remove": "Entfernen",
  "keyring.removed": "Festival entfernt. Seine Offline-Inhalte wurden gelöscht.",
  "keyring.search": "Name des Festivals oder der Stadt",
  "keyring.searchHint": "Du kannst auch dein Ticket scannen: Das Festival trägt sich selbst ein.",
  "keyring.title": "Meine Festivals",
  "lineup.all": "Ganzes Programm",
  "lineup.cancelled": "Abgesagt",
  "lineup.conflict": "Überschneidet sich mit einem anderen Favoriten",
  "lineup.conflictLine": "{{first}} und {{second}} überschneiden sich um {{minutes}} Min.",
  "lineup.conflictsTitle": "{{count}} Überschneidung(en) bei deinen Favoriten",
  "lineup.delayed": "Verspätet",
  "lineup.favorite": "Zu meinen Favoriten hinzufügen",
  "lineup.favoritesOnly": "Meine Favoriten",
  "lineup.noPerformances": "Keine Konzerte im Programm",
  "lineup.reminderBody": "{{artist}} in {{minutes}} Min. · {{stage}}",
  "lineup.reminderTitle": "Gleich geht es los",
  "lineup.remindersPlanned": "{{count}} Erinnerung(en) eingerichtet",
  "lineup.remindersUnavailable": "Erinnerungen nicht möglich – Benachrichtigungen abgelehnt",
  "lineup.removeFavorite": "Aus Favoriten entfernen",
  "lineup.title": "Programm",
  "location.denied": "Standort abgelehnt – der Plan bleibt nutzbar",
  "location.granted": "Standort aktiviert",
  "mail.reset.body": "Hallo {{name}},\n\nhier ist dein Code, um ein neues Festipal-Passwort festzulegen:\n\n{{code}}\n\nEr ist {{minutes}} Minuten gültig. Wenn du nichts angefordert hast, ignoriere diese Nachricht: Dein Passwort bleibt unverändert.\n\nFestipal",
  "mail.reset.subject": "Dein Festipal-Code: {{code}}",
  "map.bearing.east": "Richtung Osten",
  "map.bearing.north": "Richtung Norden",
  "map.bearing.northeast": "Richtung Nordosten",
  "map.bearing.northwest": "Richtung Nordwesten",
  "map.bearing.south": "Richtung Süden",
  "map.bearing.southeast": "Richtung Südosten",
  "map.bearing.southwest": "Richtung Südwesten",
  "map.bearing.west": "Richtung Westen",
  "map.closeDetail": "Schließen",
  "map.distanceMeters": "{{distance}} m entfernt",
  "map.listView": "Orte als Liste anzeigen",
  "map.loadError": "Der Plan konnte nicht geladen werden",
  "map.loading": "Plan wird vorbereitet…",
  "map.locateMe": "Mich orten",
  "map.offlineBadge": "Offline-Plan",
  "map.offlineNotice": "Plan offline verfügbar",
  "map.tapHint": "Tippe auf einen Punkt, um zu sehen, was er ist.",
  "map.title": "Geländeplan",
  "marker.car": "Mein Auto",
  "marker.dropHere": "Hier eine Markierung setzen",
  "marker.meeting": "Treffpunkt",
  "marker.needLocation": "Standort nötig, um eine Markierung zu setzen",
  "marker.other": "Markierung",
  "marker.remove": "Markierung entfernen",
  "marker.tent": "Mein Zelt",
  "me.account": "Mein Konto",
  "me.accountAnonymous": "Noch kein Konto",
  "me.diary": "Mein Heft",
  "me.diaryCount": "{{count}} Konzert(e) gesehen",
  "me.festivals": "Meine Festivals",
  "me.festivalsCount": "{{count}} Festival(s) hinzugefügt",
  "me.scan": "Code scannen",
  "me.scanHint": "Ticket, Einladung oder Gruppe",
  "me.survey": "Gelände aufnehmen",
  "me.surveyHint": "Fehlende Orte erfassen",
  "me.title": "Ich",
  "ping.age": "Vor {{minutes}} Min.",
  "ping.cancel": "Wir haben uns gefunden",
  "ping.channel": "Rufe der Gruppe",
  "ping.from": "{{name}}: „Komm zu mir!“",
  "ping.notificationBody": "Tippe, um zu sehen, wo.",
  "ping.notificationTitle": "{{name}}: „Komm zu mir!“",
  "ping.onMap": "Zu {{name}}",
  "ping.send": "Komm zu mir: Standort senden",
  "ping.sendHint": "Dein genauer Standort geht an deine Gruppe, für {{minutes}} Min.",
  "ping.sent": "Du hast deine Gruppe um {{time}} gerufen, bis {{until}}.",
  "places.allCategories": "Alle",
  "places.awaitingLocation": "Standort wird ermittelt…",
  "places.count": "{{count}} Ort(e)",
  "places.direction": "{{distance}} m {{bearing}} · {{minutes}} Min. zu Fuß",
  "places.fromHere": "Entfernungen von diesem Ort berechnen",
  "places.locationUnavailable": "Standort nicht verfügbar – Orte nach Namen sortiert",
  "places.noResult": "Kein Ort gefunden",
  "places.originDevice": "Entfernungen ab meinem Standort",
  "places.originManual": "Entfernungen ab {{place}}",
  "places.pickOrigin": "Bezugspunkt aus der Liste wählen",
  "places.searchPlaceholder": "Ort suchen",
  "places.title": "Orte",
  "places.unverified": "Nicht geprüft",
  "places.useMyLocation": "Meinen Standort verwenden",
  "poi.category.accessible": "Barrierefreier Zugang",
  "poi.category.bar": "Bar",
  "poi.category.charging": "Handy-Ladestation",
  "poi.category.entrance": "Eingang",
  "poi.category.exit": "Notausgang",
  "poi.category.firstaid": "Sanitätsstation",
  "poi.category.food": "Essen",
  "poi.category.info": "Infopunkt",
  "poi.category.lockers": "Schließfächer",
  "poi.category.stage": "Bühne",
  "poi.category.toilets": "Toiletten",
  "poi.category.water": "Wasserstelle",
  "report.comment": "Erzähl gern mehr (optional)",
  "report.failed": "Nicht angenommen. Versuch es später noch einmal.",
  "report.festival": "Das Programm oder der Plan allgemein",
  "report.kind.CANCELLED": "Abgesagt",
  "report.kind.GONE": "Gibt es nicht (mehr)",
  "report.kind.MISSING": "Ein Auftritt oder Ort fehlt",
  "report.kind.OTHER": "Etwas anderes",
  "report.kind.WRONG_PLACE": "Falsch eingezeichnet",
  "report.kind.WRONG_STAGE": "Falsche Bühne",
  "report.kind.WRONG_TIME": "Falsche Uhrzeit",
  "report.offline": "Offline: Nichts wurde gesendet. Versuch es wieder, sobald du Netz hast.",
  "report.openSource": "Quelle öffnen",
  "report.send": "Senden",
  "report.sent": "Danke! Es ist bei denen angekommen, die diese Seite pflegen.",
  "report.title": "Fehler melden",
  "report.tooMany": "Zu viele Meldungen auf einmal. Versuch es in ein paar Minuten noch einmal.",
  "safety.callEmergency": "Notruf wählen",
  "safety.emergencyTitle": "Hilfe und Sanitätsdienst",
  "safety.nearestFirstAid": "Nächste Sanitätsstation",
  "scan.close": "Scanner schließen",
  "scan.crewFound": "Gruppe erkannt: {{code}}",
  "scan.festivalFound": "Festival erkannt: {{slug}}",
  "scan.hint": "Scanne dein Ticket oder einen Gruppencode",
  "scan.invitationFound": "Einladung erkannt",
  "scan.open": "Code scannen",
  "scan.permission": "Kamera erlauben",
  "scan.permissionDenied": "Kamera abgelehnt – Code von Hand eingeben",
  "scan.privacy": "Es wird nur die Festival-Kennung gelesen. Nichts anderes vom Ticket wird gespeichert.",
  "scan.title": "Scannen",
  "scan.unknown": "Code nicht erkannt. Stammt er von einem Ticketanbieter, suche dein Festival in der Liste.",
  "shortcut.add": "Hinzufügen",
  "shortcut.later": "Später",
  "shortcut.offer": "{{name}} zum Startbildschirm hinzufügen?",
  "survey.addPhoto": "Foto hinzufügen",
  "survey.category": "Art des Ortes",
  "survey.comment": "Nützlicher Hinweis (optional)",
  "survey.intro": "Geh zum gewünschten Ort, bleib während der Messung stehen und benenne ihn.",
  "survey.measuring": "{{used}} Messwerte übernommen · Genauigkeit {{accuracy}} m",
  "survey.moderationNotice": "Jede Aufnahme wird geprüft, bevor sie in der App erscheint.",
  "survey.name": "Name des Ortes",
  "survey.needAccount": "Ein Konto ist nötig: Eine Aufnahme wird ihrer Urheberin oder ihrem Urheber zugeordnet.",
  "survey.needLocation": "Für eine Aufnahme wird Zugriff auf den Standort benötigt.",
  "survey.open": "Kartieren",
  "survey.photoAttached": "Foto angehängt",
  "survey.photoRejected": "Foto vom automatischen Filter abgewiesen. Die Aufnahme selbst wurde gesendet.",
  "survey.queue": "Meine Aufnahmen",
  "survey.queueEmpty": "Noch keine Aufnahmen.",
  "survey.rejected": "{{count}} Messwert(e) verworfen, zu weit von den übrigen entfernt",
  "survey.removePhoto": "Foto entfernen",
  "survey.save": "Aufnahme speichern",
  "survey.send": "Jetzt senden",
  "survey.sendFailed": "Senden derzeit nicht möglich. Die Aufnahmen bleiben auf dem Gerät.",
  "survey.sending": "Wird gesendet…",
  "survey.start": "Messung starten",
  "survey.statusPending": "Wartet auf Netz",
  "survey.statusRejected": "Aufnahme vom Server abgelehnt.",
  "survey.statusSent": "Gesendet",
  "survey.stop": "Messung beenden",
  "survey.title": "Geländeaufnahme",
  "survey.tooImprecise": "Die Genauigkeit reicht noch nicht. Entferne dich von Metallstrukturen und warte.",
  "survey.waiting": "Warten auf GPS…",
  "tab.crew": "Gruppe",
  "tab.diary": "Tagebuch",
  "tab.lineup": "Programm",
  "tab.map": "Plan",
  "tab.me": "Ich",
  "tab.places": "Orte"
}
